<template>

    <div class="product-card d-flex align-items-stretch mpshadow rounded p-4" :class="{ 'product-card--deactivated' : productIsDeactivated }" @click="executeClick" style="cursor: pointer">
        <!-- Top left label -->
        <div class="product-ribbon" v-if="product.isFeatured && !productDiscounted">
            <div class="product-featured-container d-inline-block">
                        <!-- <label-tag class="product-ribbon label-sm bg-yellow" v-if="product.isFeatured"></label-tag> -->
                <div class="product-featured px-2 font-weight-bolder label">
                    <img class="featured-icon" src="images/icon-product-featured.svg" alt=""/>&nbsp;HOT
                </div>
            </div>
        </div>

        <div class="product-image-container d-flex">
            <img class="card-image img font-sm align-self-center mx-auto" :src="'/image/' + productImage" @error="$root.imageAlt" alt="" />
        </div>
        <div class="product-details-container d-flex flex-wrap justify-content-between">
            <!-- details for carousel, hidden on full size -->
            <div class="product-details-short col-12 p-0">
                <span class="font-weight-bolder" v-text="product.productName"></span>
                <span class="text-dark-grey" v-text="product.shortDesc"></span>
            </div>

            <!-- details on full size, hidden on carousel -->
            <div class="product-details-long col-12 p-0">
                <div class="product-title font-md font-weight-bolder" v-text="product.productName"></div>
                <div class="product-short-desc font-sm text-dark-grey" v-text="product.shortDesc"></div>
            </div>

            <div class="col-12 p-0 align-self-end position-static">
                <!-- Discount Percent -->
                <div class="product-discount-container d-inline-block" v-if="productDiscounted">
                    <div class="product-discount px-2 text-white" v-html="discountPercentage + '% OFF'"></div>
                </div>
                <!-- Monthly Installment Rate -->
                <div v-if="!productIsDeactivated" :class="{ 'text-orange' : productDiscounted, 'text-red': !productDiscounted }" class="font-sm font-weight-bolder d-inline-block" v-html="productMonthlyInstallment"></div>
                <div v-else class="text-gray-disabled font-sm font-weight-bolder d-inline-block" v-html="'Sold Out'"></div>
                <!-- Terms -->
                <div v-if="!productIsDeactivated" class="font-xxs text-dark-grey d-inline-block" v-html="'&times;&nbsp;' + product.financing.terms + '&nbsp;months'"></div>
            </div>
        </div>
    </div>

</template>

<script>
    import productMixin from '../components/productMixin'

    export default {
        mixins: [productMixin],

        props: ["product", "optionalProps"],

        computed: {
            productDetails: function() {
                return {
                    id: this.product.id,
                    name: this.product.productName,
                    desc: this.product.shortDesc,
                    brand: this.fetchProductBrand(),
                    category: this.fetchProductCategory(),
                    from: this.$route.fullPath,
                    from_campaign: 'N'
                }
            },
            getOptionalProps: function() {
                return this.optionalProps;
            },
            productMonthlyInstallment: function() {
                return this.$root.formatCurrency(this.product.financing.finalMonthlyInstallment);
            },
            productDiscounted: function() {
                return this.hasDiscount(this.product.financing.discount)
            },
            discountPercentage: function() {
                return Math.round(this.product.financing.discount.discountPercentage * 100);
            },
            productIsDeactivated: function() {
                return (this.product.isActive === 'false' || this.product.isActive === false);
            },
            productImage: function() {
                return this.product.imageId? this.product.imageId[0] : 0
            },
        },

        methods: {
            executeClick: function() {
                if (!this.productIsDeactivated) {
                    // go to product detail
                    this.$router.push({
                        name: 'product',
                        query: Object.assign(this.productDetails, this.getOptionalProps)
                    });
                } else {

                    // send ga
                    ga('send', {
                        hitType: 'event',
                        eventCategory: 'Inactive Products',
                        eventAction: 'Click',
                        eventLabel: this.product.productName + (this.product.shortDesc ? (' - ' + this.product.shortDesc) : ''),
                    });

                    // open modal
                    this.$root.openModal('modal_deactivated_product', {product: this.product});
                }
            },
            fetchProductCategory: function() {
                if (_.has(this.product, 'productBslElasticCategory')) {
                    // used on carousels, product lists
                    return _.get(this.product, 'productBslElasticCategory[0].categoryName', '');

                } else if (_.has(this.product, 'parentCategory')) {
                    // used on tips and stories
                    return _.get(this.product, 'parentCategory.name', '');

                } else if (_.has(this.product, 'categoryInfo[0].name')) {
                    // used on campaigns
                    return _.get(this.product, 'categoryInfo[0].name', '');

                } else {
                    return '';

                }
            },
            fetchProductBrand: function() {
                if (_.has(this.product, 'brandName')) {
                    // used on carousels, product lists
                    return _.get(this.product, 'brandName', '');

                } else if (_.has(this.product, 'brandInfo')) {
                    // used on campaigns, tips and stories
                    return _.get(this.product, 'brandInfo.productName', '');

                } else {
                    return '';

                }
            }
        }
    }
</script>
